import { _ as _defineProperty } from '../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../unsorted/objectWithoutProperties.js';
import { _ as _toConsumableArray } from '../unsorted/toConsumableArray.js';
import { m as merge } from '../unsorted/index.js';
import { SHORTHAND_CSS_RULE_MAPPING } from '../constants.js';
import { isError } from './textStyleHelpers.js';

var _excluded = ["theme", "size", "renderSxAtSize"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var inputResetStyles = function inputResetStyles(disabled) {
  return {
    margin: 0,
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    cursor: disabled ? "default" : "pointer",
    border: "none",
    appearance: "none"
  };
};
function isSafeSize(size, safeSizes) {
  return typeof size === "string" && safeSizes.includes(size);
}
function getStartingSize(size, defaultSize, safeSizes) {
  var sizeAsArray = Array.isArray(size) ? _toConsumableArray(size) : [size];
  var startingSize = sizeAsArray.shift();
  return isSafeSize(startingSize, safeSizes) ? startingSize : defaultSize;
}
function setDefaultSxBackgroundColor(sx, color) {
  switch (true) {
    case sx.bg !== undefined:
      return {
        bg: color
      };
    case sx.bgc !== undefined:
      return {
        bgc: color
      };
    case sx.backgroundColor !== undefined:
      return {
        backgroundColor: color
      };
    case sx.background !== undefined:
    default:
      return {
        background: color
      };
  }
}
function getResponsiveSx(_ref) {
  var theme = _ref.theme,
    size = _ref.size,
    renderSxAtSize = _ref.renderSxAtSize,
    props = _objectWithoutProperties(_ref, _excluded);
  var sizeAsArray = Array.isArray(size) ? _toConsumableArray(size) : [size];
  sizeAsArray.shift();
  var sizeStyles = merge.apply(void 0, _toConsumableArray(sizeAsArray.map(function (responsiveSize, index) {
    if (responsiveSize != null && !isError(responsiveSize)) {
      var _theme$base$breakpoin;
      var mediaStyleRule = "@media screen and (min-width: ".concat((_theme$base$breakpoin = theme.base.breakpointAsArray) === null || _theme$base$breakpoin === void 0 ? void 0 : _theme$base$breakpoin[index], "px)");
      return _defineProperty({}, mediaStyleRule, renderSxAtSize(_objectSpread({
        size: responsiveSize,
        theme: theme
      }, props)));
    }
    return {};
  })));
  return sizeStyles;
}

// @NOTE: these functions can likely be deprecated, due to changes in the
// way sx is handled - they should no longer be needed
var setDefaultWidthSx = function setDefaultWidthSx(sx, width) {
  return setDefaultSxProp("w", sx, width);
};
var setDefaultHeightSx = function setDefaultHeightSx(sx, height) {
  return setDefaultSxProp("h", sx, height);
};
var setDefaultSxTextColor = function setDefaultSxTextColor(sx, color) {
  return setDefaultSxProp("c", sx, color);
};
function setDefaultSxProp(abbreviated, sx, defaultValue) {
  var full = SHORTHAND_CSS_RULE_MAPPING[abbreviated];
  return sx[abbreviated] ? _defineProperty({}, abbreviated, defaultValue) : _defineProperty({}, full, defaultValue);
}

export { getResponsiveSx, getStartingSize, inputResetStyles, isSafeSize, setDefaultHeightSx, setDefaultSxBackgroundColor, setDefaultSxProp, setDefaultSxTextColor, setDefaultWidthSx };
//# sourceMappingURL=styleHelpers.js.map
